module.exports = __webpack_public_path__ + "img/flexben-logo.8ddb6f26.svg";